/** Canonical ticket statuses accepted by ticketing-api (TicketController.ALLOWED_STATUSES). */
export const TICKET_STATUS_OPTIONS = [
  'Open',
  'In Progress',
  'Waiting for customer',
  'Escalated',
  'Done',
];
